import { render } from "./Retagging.vue?vue&type=template&id=47f0790b"
import script from "./Retagging.vue?vue&type=script&lang=js"
export * from "./Retagging.vue?vue&type=script&lang=js"

import "./Retagging.vue?vue&type=style&index=0&id=47f0790b&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__